const redReflexProcessor=(element)=>
{
let assembledElement = " loss of the red reflex"

let sideText = ""
switch (element["Side"]) {
    case "Right":
        sideText = " in the right eye"
        break;

    case "Left":
        sideText = " in the right eye"
        break;

    case "Bilateral":
        sideText = " in the both eyes"
        break;

    default:
        sideText = "in any eye"
        break;
    }
assembledElement += sideText

if (element["Colour"] !== "")
    {
    assembledElement += ` which is now reflecting ${element["Colour"].toLowerCase()}`  
    }

if (element["Eye_inflammed"])
    {
    assembledElement += `. The affected eye is ${element["Eye_inflammed"].toLowerCase()}`
    if (element["Vision_in_affected_eye"] !== "")
        {
        assembledElement += " and the vision in this eye is" 
        }
    }
else if (element["Vision_in_affected_eye"] !== "")  
    {
    assembledElement += " the vision in the affected eye is" 
    }

if (element["Vision_in_affected_eye"] !== "") 
    {
     let visionText = ""
    switch (element["Vision_in_affected_eye"]) {
        case "Normal vison":
            visionText = " normal"
            break;

        case "Blurred vision":
            visionText = " blurred"
            break;

        case "Abscent vision":
            visionText = " abscent"
            break
    
        default:
            break;
    }
    assembledElement += visionText

    }


return (assembledElement)
}

export default redReflexProcessor